// VERA-825 / VERA-246: Payment-method section for the tag shop checkout card.
// Section header ("Payment method" + "Change" button) plus the selected card row
// (card-brand icon + label + "Visa •••• 9385" + edit pencil). Falls back to an
// "Add payment method" affordance when the company has no saved cards.

import React from 'react';

import {Stack, Typography} from '@mui/material';
import {Button, Skeleton} from '@repo/ui';
import {PlusIcon} from 'lucide-react';

import type {PaymentMethodRow} from 'hooks/api/usePaymentMethods';
import {PaymentMethodPreview} from 'components/display/PaymentMethodPreview';

interface CheckoutPaymentRowProps {
  method: PaymentMethodRow | null;
  isLoading: boolean;
  onChange(): void;
  onAdd(): void;
}

export const CheckoutPaymentRow = ({
  method,
  isLoading,
  onChange,
  onAdd,
}: CheckoutPaymentRowProps) => {
  return (
    <Stack spacing={4}>
      <Typography variant="body1">Payment method</Typography>

      {isLoading ? (
        // Neutral rectangle — at load we don't yet know if this becomes a saved
        // card row or an "Add" button, so don't mis-preview an avatar layout.
        <Skeleton height={40} />
      ) : method ? (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={3}
        >
          <PaymentMethodPreview method={method} />

          <Button
            variant="secondary"
            onClick={onChange}
            sx={{flexShrink: 0}}
          >
            Change
          </Button>
        </Stack>
      ) : (
        <Button
          variant="secondary"
          startIcon={<PlusIcon size={18} strokeWidth={1} />}
          onClick={onAdd}
          sx={{alignSelf: 'flex-start'}}
        >
          Add
        </Button>
      )}
    </Stack>
  );
};
